import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { RepositoriesService } from 'app/API';
import { TRepository } from 'app/types/entities/TRepository';
import { useState } from 'react';

type TProps = {
  repository: TRepository;
  onCancel: () => void;
  onSuccess: () => void;
};

export const DeleteRepositoryModal = ({ repository, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const deleteHandler = async () => {
    setIsSubmitting(true);
    const data = await call(RepositoriesService.remove({ repositoryId: repository.id }));
    if (!data.error) {
      onSuccess();
    } else {
      setError(data.error as string);
    }
    setIsSubmitting(false);
  };

  return (
    <ModalWrapper width="330px">
      <ModalTitle>Confirm</ModalTitle>
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <div className="text-center">
        Are you sure you want to delete &quot;{repository.name}&quot;? <br />
        Associated attachments will also be deleted.
      </div>
      {error && <div className="-mt-5 text-center text-[10px] font-medium text-[#ff2f2f]">{error}</div>}
      <div className="flex justify-between">
        <OutlinedButton onClick={onCancel} style={{ width: '130px' }}>
          Cancel
        </OutlinedButton>
        <Button onClick={deleteHandler} disabled={isSubmitting} style={{ width: '130px' }}>
          Delete
        </Button>
      </div>
    </ModalWrapper>
  );
};
